import {ArrUtil, ensure, hasKey} from 'yougile-util'
import {findIdInWorkflow} from '../workflow-ids'
import {Context} from './context'
import {TypedValue} from './values'

export type NumberValue =
  | number
  | {value: number}
  | {count: TypedValue}
  | {sum: NumberValue[]}
  | {field: string}

export const numberValueToNumber = (
  value: NumberValue,
  ctx: Context,
  recur = 0
): number | undefined => {
  const {workflow, task} = ctx
  ensure(recur < 10, 'Too deep recursion')
  if (typeof value === 'number') {
    return value
  }
  if (hasKey(value, 'value')) {
    return Number(value.value)
  }
  if (hasKey(value, 'sum')) {
    ensure(value.sum instanceof Array, 'Incorrect number value sum')
    const nums = ArrUtil.defined(
      value.sum.map(s => numberValueToNumber(s, ctx, recur + 1))
    )
    return nums.reduce((a, b) => a + b, 0)
  }
  if (hasKey(value, 'field')) {
    const fieldId = findIdInWorkflow(workflow.ids, 'fields', value.field)
    ensure(fieldId, 'Field not found', value.field)
    return Number(task.data?.workflowState?.fields?.[fieldId])
  }
  ensure(false, 'Unsupported number value', value)
}
